var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { keyframes } from '@emotion/core';
import { createThemedComponent } from '../util/createThemedComponent';
var spinnerAnimation = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n0% {\n  transform: rotateZ(0deg);\n}\n100% {\n  transform: rotateZ(360deg)\n}\n"], ["\n0% {\n  transform: rotateZ(0deg);\n}\n100% {\n  transform: rotateZ(360deg)\n}\n"])));
var circleAnimation = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n0%,\n25% {\n  stroke-dashoffset: 280;\n  transform: rotate(0);\n}\n\n50%,\n75% {\n  stroke-dashoffset: 75;\n  transform: rotate(45deg);\n}\n\n100% {\n  stroke-dashoffset: 280;\n  transform: rotate(360deg);\n}\n"], ["\n0%,\n25% {\n  stroke-dashoffset: 280;\n  transform: rotate(0);\n}\n\n50%,\n75% {\n  stroke-dashoffset: 75;\n  transform: rotate(45deg);\n}\n\n100% {\n  stroke-dashoffset: 280;\n  transform: rotate(360deg);\n}\n"])));
export var Spinner = createThemedComponent(['size'], {
    as: function (_a) {
        var className = _a.className;
        return (jsx("div", { sx: { display: 'inline-block', width: '1em', height: '1em' }, className: className },
            jsx("svg", { viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg", css: {
                    animation: "2s linear infinite ".concat(spinnerAnimation),
                    width: '100%',
                    height: '100%',
                } },
                jsx("circle", { cx: "50", cy: "50", r: "45", css: {
                        animation: "1.4s ease-in-out infinite both ".concat(circleAnimation),
                        display: 'block',
                        fill: 'transparent',
                        stroke: 'currentColor',
                        strokeLinecap: 'round',
                        strokeDasharray: 283,
                        strokeDashoffset: 280,
                        strokeWidth: 10,
                        transformOrigin: '50% 50%',
                    } }))));
    },
    themeKey: 'spinners',
    size: 'md',
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=Spinner.js.map